import {
  Environment
} from '@vodacom/web-env';

import {
  AppState
} from 'helpers';

export class SearchProvider {

  static BASE_URL = Environment.current.apiPath;
  static STATE = AppState.with('SearchProvider');

  static async getSearchResults(
    searchTerm
  ) {

    const cachedItem = SearchProvider.getCachedItem(`wiki--search--${searchTerm}`);

    if (!!cachedItem) {
      return cachedItem;
    }

    return SearchProvider.STATE.makeServiceCall(
      `${SearchProvider.BASE_URL}search`,
      {
        method: 'GET',
        queryParams: {
          'term': searchTerm
        },
        cacheKey: `wiki--search--${searchTerm}`
      }
    )
      .then((res) => {
        if (!res.result) {
          return {
            ok: false,
            error: new Error('Wiki search error'),
            trace: null,
            date: null,
            result: null,
            code: res.code,
            stamp: new Date()
          };
        }

        return res;
      })
      .catch((error) => {
        return {
          ok: false,
          error: error,
          trace: null,
          date: null,
          result: null,
          code: error?.response?.status,
          stamp: new Date()
        };
      });
  }

  static getCachedItem(key, fallback) {
    return SearchProvider.STATE.getItem(key, fallback);
  }
}
